/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/** Body_get_access_token_api_v1_auth_token_post */
export interface BodyGetAccessTokenApiV1AuthTokenPost {
  /** Grant Type */
  grant_type?: string | null
  /** Username */
  username: string
  /** Password */
  password: string
  /**
   * Scope
   * @default ""
   */
  scope?: string
  /** Client Id */
  client_id?: string | null
  /** Client Secret */
  client_secret?: string | null
}

/** CommentsIn */
export interface CommentsIn {
  /** Content */
  content: string
}

/** CommentsOut */
export interface CommentsOut {
  /** Created At */
  created_at: string
  /** Created By */
  created_by: string
  /** Updated At */
  updated_at: string
  /** Updated By */
  updated_by: string
  /** Content */
  content: string
  /** Cmt Id */
  cmt_id: string
  /** Pub Id */
  pub_id: string
  /** User Id */
  user_id: string
  /** Parent Cmt Id */
  parent_cmt_id: string | null
  /**
   * Child Cmts
   * @default []
   */
  child_cmts: CommentsOut[]
}

/** ControlNetModelsResponse */
export interface ControlNetModelsResponse {
  /**
   * Models
   * @default []
   */
  models: string[]
}

/** ControlNetModulesResponse */
export interface ControlNetModulesResponse {
  /**
   * Modules
   * @default []
   */
  modules: string[]
}

/** ControlNetUnit */
export interface ControlNetUnit {
  /**
   * Input Image
   * Base64 encoded input image with no header
   * @default ""
   * @example "iVBORw0KGgoAAAANSUhEUgAAAg....."
   */
  input_image?: string | null
  /**
   * Mask
   * Base64 encoded mask for the image with no header
   * @example "iVBORw0KGgoAAAANSUhEUgAAAg....."
   */
  mask?: string | null
  /**
   * Module
   * Name of the preprocessor(module)
   * @default "canny"
   * @example "canny"
   */
  module?: string | null
  /**
   * Model
   * User input, Name of the controlnet model, get with /api/v1/creations/controlnet-models
   * @default "control_v11p_sd15_canny"
   * @example "control_v11p_sd15_canny"
   */
  model?: string | null
  /**
   * Weight
   * User input, weighting value
   * @default 1
   * @example 1
   */
  weight?: number | null
  /**
   * Resize Mode
   * Image resizing mode: 'Just Resize', 'Crop and Resize','Resize and Fill'
   * @default "Crop and Resize"
   * @example "Crop and Resize"
   */
  resize_mode?: string | null
  /**
   * Lowvram
   * Use low VRAM mode
   * @default false
   * @example true
   */
  lowvram?: boolean | null
  /**
   * Processor Res
   * Resolution for the processor
   * @default 512
   * @example 512
   */
  processor_res?: number | null
  /**
   * Threshold A
   * First threshold value
   * @default 1
   * @example 64
   */
  threshold_a?: number | null
  /**
   * Threshold B
   * Second threshold value
   * @default 0
   * @example 64
   */
  threshold_b?: number | null
  /**
   * Guidance
   * Guidance value
   * @default 1
   * @example 1
   */
  guidance?: number | null
  /**
   * Guidance Start
   * Start value for guidance
   * @default 0
   * @example 0
   */
  guidance_start?: number | null
  /**
   * Guidance End
   * End value for guidance
   * @default 1
   * @example 1
   */
  guidance_end?: number | null
  /**
   * Control Mode
   * Mode for control: 0:Balanced, 1:Prompt more important, 2:Controlnet more important
   * @default 0
   * @example 0
   */
  control_mode?: number | null
  /**
   * Pixel Perfect
   * Enable pixel perfect
   * @default true
   * @example true
   */
  pixel_perfect?: boolean | null
}

/** HTTPValidationError */
export interface HTTPValidationError {
  /** Detail */
  detail?: ValidationError[]
}

/** ImagesIn */
export interface ImagesIn {
  /** Request Id */
  request_id: string
  /** Img Url */
  img_url: string
  /** Type */
  type: string
  /** Info */
  info: string
}

/** ImagesOut */
export interface ImagesOut {
  /** Created At */
  created_at: string
  /** Created By */
  created_by: string
  /** Updated At */
  updated_at: string
  /** Updated By */
  updated_by: string
  /** Request Id */
  request_id: string
  /** Img Url */
  img_url: string
  /** Type */
  type: string
  /** Info */
  info: string
  /** Img Id */
  img_id: string
  /** Pub Id */
  pub_id: string
  /** User Id */
  user_id: string
}

/** Img2ImgGenerationResponse */
export interface Img2ImgGenerationResponse {
  /**
   * Images
   * @default []
   */
  images: string[]
  params: Img2ImgOutput
  /**
   * Info
   * @default {}
   */
  info: any
}

/** Img2Img */
export interface Img2ImgInput {
  /**
   * Init Images
   * User input: Initial images to start with
   * @default []
   * @example ["data:image/png;base64,..."]
   */
  init_images?: string[] | null
  /**
   * Resize Mode
   * Mode for resizing the image
   * @default 0
   * @example 1
   */
  resize_mode?: number | null
  /**
   * Denoising Strength
   * User input: Strength for denoising the image(importance of the initial image)
   * @default 0.75
   * @example 0.6
   */
  denoising_strength?: number | null
  /**
   * Image Cfg Scale
   * Image configuration scaling factor
   * @default 1.5
   * @example 1.2
   */
  image_cfg_scale?: number | null
  /**
   * Mask
   * User input: Path to the mask image
   * @example "data:image/png;base64,..."
   */
  mask?: string | null
  /**
   * Mask Blur
   * Amount of blur to apply to the mask
   * @default 3
   * @example 4
   */
  mask_blur?: number | null
  /**
   * Mask Blur X
   * Amount of blur to apply to the mask on x-axis
   * @default 3
   * @example 4
   */
  mask_blur_x?: number | null
  /**
   * Mask Blur Y
   * Amount of blur to apply to the mask on y-axis
   * @default 3
   * @example 4
   */
  mask_blur_y?: number | null
  /**
   * Inpainting Fill
   * Mode for inpainting fill
   * @default 0
   * @example 1
   */
  inpainting_fill?: number | null
  /**
   * Inpaint Full Res
   * Perform inpainting at full resolution
   * @default true
   * @example false
   */
  inpaint_full_res?: boolean | null
  /**
   * Inpaint Full Res Padding
   * Padding to use when inpainting at full resolution
   * @default 0
   * @example 2
   */
  inpaint_full_res_padding?: number | null
  /**
   * Inpainting Mask Invert
   * User input: Whether to invert the inpainting mask or not
   * @default 1
   * @example 0
   */
  inpainting_mask_invert?: number | null
  /**
   * Initial Noise Multiplier
   * Multiplier for the initial noise
   * @default 1
   * @example 1.2
   */
  initial_noise_multiplier?: number | null
  /**
   * Prompt
   * User input: Text prompt to guide image generation
   * @default ""
   * @example "A beautiful sunset"
   */
  prompt?: string | null
  /**
   * Styles
   * User input: List of styles to be applied
   * @default []
   * @example ["Style: Anime","Style: Digital art"]
   */
  styles?: string[] | null
  /**
   * Seed
   * Random seed for transformation
   * @default -1
   * @example 42
   */
  seed?: number | null
  /**
   * Subseed
   * Subseed for finer control of randomness
   * @default -1
   * @example 23
   */
  subseed?: number | null
  /**
   * Subseed Strength
   * Strength of the subseed effect
   * @default 0
   * @example 0.5
   */
  subseed_strength?: number | null
  /**
   * Seed Resize From H
   * Resize seed image from given height
   * @default 0
   * @example 256
   */
  seed_resize_from_h?: number | null
  /**
   * Seed Resize From W
   * Resize seed image from given width
   * @default 0
   * @example 256
   */
  seed_resize_from_w?: number | null
  /**
   * Sampler Name
   * Name of the sampler to use
   * @default "Euler a"
   * @example "Euler b"
   */
  sampler_name?: string | null
  /**
   * Batch Size
   * User input: Size of batches to process
   * @default 1
   * @example 5
   */
  batch_size?: number | null
  /**
   * N Iter
   * Number of iterations
   * @default 1
   * @example 10
   */
  n_iter?: number | null
  /**
   * Steps
   * Number of processing steps
   * @default 50
   * @example 100
   */
  steps?: number | null
  /**
   * Cfg Scale
   * Configuration scaling factor
   * @default 7
   * @example 5.5
   */
  cfg_scale?: number | null
  /**
   * Width
   * User input: Width of the output image
   * @default 1024
   * @example 256
   */
  width?: number | null
  /**
   * Height
   * User input: Height of the output image
   * @default 1024
   * @example 256
   */
  height?: number | null
  /**
   * Restore Faces
   * User input: Whether to restore faces in the image or not
   * @default false
   * @example true
   */
  restore_faces?: boolean | null
  /**
   * Tiling
   * Whether to tile the image or not
   * @default false
   * @example true
   */
  tiling?: boolean | null
  /**
   * Do Not Save Samples
   * Don't save intermediate sample images
   * @default false
   * @example true
   */
  do_not_save_samples?: boolean | null
  /**
   * Do Not Save Grid
   * Don't save the output in grid format
   * @default false
   * @example true
   */
  do_not_save_grid?: boolean | null
  /**
   * Negative Prompt
   * User input: Negative text prompt to guide image generation away from
   * @default "nudity, poorly Rendered face, poorly drawn face, poor facial details, poorly drawn hands, poorly rendered hands, low resolution, images cut out at the top, images cut out at the left, images cut out at the right, images cut out at the bottom, bad composition, mutated body parts, blurry image, disfigured, oversaturated, bad anatomy, deformed body features"
   * @example "A stormy night"
   */
  negative_prompt?: string | null
  /**
   * Eta
   * Parameter eta for controlling aspects of the transformation
   * @default 1
   * @example 0.9
   */
  eta?: number | null
  /**
   * S Min Uncond
   * Minimum unconditional value for s
   * @default 0
   * @example 0.1
   */
  s_min_uncond?: number | null
  /**
   * S Churn
   * Churn value for s
   * @default 0
   * @example 0.2
   */
  s_churn?: number | null
  /**
   * S Tmax
   * Maximum temperature for s
   * @default 0
   * @example 1
   */
  s_tmax?: number | null
  /**
   * S Tmin
   * Minimum temperature for s
   * @default 0
   * @example 0.2
   */
  s_tmin?: number | null
  /**
   * S Noise
   * Noise value for s
   * @default 1
   * @example 0.8
   */
  s_noise?: number | null
  /**
   * Override Settings
   * Settings that will override the default ones
   * @default {}
   * @example {"setting1":"value1"}
   */
  override_settings?: object | null
  /**
   * Override Settings Restore Afterwards
   * Whether to restore the overridden settings after processing or not
   * @default true
   * @example false
   */
  override_settings_restore_afterwards?: boolean | null
  /**
   * Script Args
   * Arguments to be passed to any scripts
   * @default []
   * @example ["arg1","arg2"]
   */
  script_args?: any[] | null
  /**
   * Sampler Index
   * Index of the sampler to use
   * @default ""
   * @example "3"
   */
  sampler_index?: string | null
  /**
   * Include Init Images
   * Whether to include the initial images in the output or not
   * @default false
   * @example false
   */
  include_init_images?: boolean | null
  /**
   * Script Name
   * Name of the script to run
   * @default ""
   * @example "scriptA"
   */
  script_name?: string | null
  /**
   * Send Images
   * Whether to send images to an external service or not
   * @default true
   * @example false
   */
  send_images?: boolean | null
  /**
   * Save Images
   * Whether to save the generated images or not
   * @default false
   * @example true
   */
  save_images?: boolean | null
  /**
   * Alwayson Scripts
   * Always on scripts, value depends on controlnet switch
   * @default {}
   * @example {"ControlNet":[{"model":"control_v11p_sd15_canny"},{"module":"openpose"}]}
   */
  alwayson_scripts?: object | null
}

/** Img2Img */
export interface Img2ImgOutput {
  /**
   * Init Images
   * User input: Initial images to start with
   * @default []
   * @example ["data:image/png;base64,..."]
   */
  init_images: string[] | null
  /**
   * Resize Mode
   * Mode for resizing the image
   * @default 0
   * @example 1
   */
  resize_mode: number | null
  /**
   * Denoising Strength
   * User input: Strength for denoising the image(importance of the initial image)
   * @default 0.75
   * @example 0.6
   */
  denoising_strength: number | null
  /**
   * Image Cfg Scale
   * Image configuration scaling factor
   * @default 1.5
   * @example 1.2
   */
  image_cfg_scale: number | null
  /**
   * Mask
   * User input: Path to the mask image
   * @example "data:image/png;base64,..."
   */
  mask: string | null
  /**
   * Mask Blur
   * Amount of blur to apply to the mask
   * @default 3
   * @example 4
   */
  mask_blur: number | null
  /**
   * Mask Blur X
   * Amount of blur to apply to the mask on x-axis
   * @default 3
   * @example 4
   */
  mask_blur_x: number | null
  /**
   * Mask Blur Y
   * Amount of blur to apply to the mask on y-axis
   * @default 3
   * @example 4
   */
  mask_blur_y: number | null
  /**
   * Inpainting Fill
   * Mode for inpainting fill
   * @default 0
   * @example 1
   */
  inpainting_fill: number | null
  /**
   * Inpaint Full Res
   * Perform inpainting at full resolution
   * @default true
   * @example false
   */
  inpaint_full_res: boolean | null
  /**
   * Inpaint Full Res Padding
   * Padding to use when inpainting at full resolution
   * @default 0
   * @example 2
   */
  inpaint_full_res_padding: number | null
  /**
   * Inpainting Mask Invert
   * User input: Whether to invert the inpainting mask or not
   * @default 1
   * @example 0
   */
  inpainting_mask_invert: number | null
  /**
   * Initial Noise Multiplier
   * Multiplier for the initial noise
   * @default 1
   * @example 1.2
   */
  initial_noise_multiplier: number | null
  /**
   * Prompt
   * User input: Text prompt to guide image generation
   * @default ""
   * @example "A beautiful sunset"
   */
  prompt: string | null
  /**
   * Styles
   * User input: List of styles to be applied
   * @default []
   * @example ["Style: Anime","Style: Digital art"]
   */
  styles: string[] | null
  /**
   * Seed
   * Random seed for transformation
   * @default -1
   * @example 42
   */
  seed: number | null
  /**
   * Subseed
   * Subseed for finer control of randomness
   * @default -1
   * @example 23
   */
  subseed: number | null
  /**
   * Subseed Strength
   * Strength of the subseed effect
   * @default 0
   * @example 0.5
   */
  subseed_strength: number | null
  /**
   * Seed Resize From H
   * Resize seed image from given height
   * @default 0
   * @example 256
   */
  seed_resize_from_h: number | null
  /**
   * Seed Resize From W
   * Resize seed image from given width
   * @default 0
   * @example 256
   */
  seed_resize_from_w: number | null
  /**
   * Sampler Name
   * Name of the sampler to use
   * @default "Euler a"
   * @example "Euler b"
   */
  sampler_name: string | null
  /**
   * Batch Size
   * User input: Size of batches to process
   * @default 1
   * @example 5
   */
  batch_size: number | null
  /**
   * N Iter
   * Number of iterations
   * @default 1
   * @example 10
   */
  n_iter: number | null
  /**
   * Steps
   * Number of processing steps
   * @default 50
   * @example 100
   */
  steps: number | null
  /**
   * Cfg Scale
   * Configuration scaling factor
   * @default 7
   * @example 5.5
   */
  cfg_scale: number | null
  /**
   * Width
   * User input: Width of the output image
   * @default 1024
   * @example 256
   */
  width: number | null
  /**
   * Height
   * User input: Height of the output image
   * @default 1024
   * @example 256
   */
  height: number | null
  /**
   * Restore Faces
   * User input: Whether to restore faces in the image or not
   * @default false
   * @example true
   */
  restore_faces: boolean | null
  /**
   * Tiling
   * Whether to tile the image or not
   * @default false
   * @example true
   */
  tiling: boolean | null
  /**
   * Do Not Save Samples
   * Don't save intermediate sample images
   * @default false
   * @example true
   */
  do_not_save_samples: boolean | null
  /**
   * Do Not Save Grid
   * Don't save the output in grid format
   * @default false
   * @example true
   */
  do_not_save_grid: boolean | null
  /**
   * Negative Prompt
   * User input: Negative text prompt to guide image generation away from
   * @default "nudity, poorly Rendered face, poorly drawn face, poor facial details, poorly drawn hands, poorly rendered hands, low resolution, images cut out at the top, images cut out at the left, images cut out at the right, images cut out at the bottom, bad composition, mutated body parts, blurry image, disfigured, oversaturated, bad anatomy, deformed body features"
   * @example "A stormy night"
   */
  negative_prompt: string | null
  /**
   * Eta
   * Parameter eta for controlling aspects of the transformation
   * @default 1
   * @example 0.9
   */
  eta: number | null
  /**
   * S Min Uncond
   * Minimum unconditional value for s
   * @default 0
   * @example 0.1
   */
  s_min_uncond: number | null
  /**
   * S Churn
   * Churn value for s
   * @default 0
   * @example 0.2
   */
  s_churn: number | null
  /**
   * S Tmax
   * Maximum temperature for s
   * @default 0
   * @example 1
   */
  s_tmax: number | null
  /**
   * S Tmin
   * Minimum temperature for s
   * @default 0
   * @example 0.2
   */
  s_tmin: number | null
  /**
   * S Noise
   * Noise value for s
   * @default 1
   * @example 0.8
   */
  s_noise: number | null
  /**
   * Override Settings
   * Settings that will override the default ones
   * @default {}
   * @example {"setting1":"value1"}
   */
  override_settings: object | null
  /**
   * Override Settings Restore Afterwards
   * Whether to restore the overridden settings after processing or not
   * @default true
   * @example false
   */
  override_settings_restore_afterwards: boolean | null
  /**
   * Script Args
   * Arguments to be passed to any scripts
   * @default []
   * @example ["arg1","arg2"]
   */
  script_args: any[] | null
  /**
   * Sampler Index
   * Index of the sampler to use
   * @default ""
   * @example "3"
   */
  sampler_index: string | null
  /**
   * Include Init Images
   * Whether to include the initial images in the output or not
   * @default false
   * @example false
   */
  include_init_images: boolean | null
  /**
   * Script Name
   * Name of the script to run
   * @default ""
   * @example "scriptA"
   */
  script_name: string | null
  /**
   * Send Images
   * Whether to send images to an external service or not
   * @default true
   * @example false
   */
  send_images: boolean | null
  /**
   * Save Images
   * Whether to save the generated images or not
   * @default false
   * @example true
   */
  save_images: boolean | null
  /**
   * Alwayson Scripts
   * Always on scripts, value depends on controlnet switch
   * @default {}
   * @example {"ControlNet":[{"model":"control_v11p_sd15_canny"},{"module":"openpose"}]}
   */
  alwayson_scripts: object | null
}

/** Img2ImgRequest */
export interface Img2ImgRequest {
  /** img2img parameters */
  params: Img2ImgInput
  /**
   * Controlnet Units
   * List of Control Network Units
   * @default []
   * @example []
   */
  controlnet_units?: ControlNetUnit[] | null
  /**
   * Options
   * Additional options for the request, use to set different base models
   * @default {}
   * @example {"sd_model_checkpoint":"sd_xl_base_1.0.safetensors"}
   */
  options?: object | null
}

/** LikesOut */
export interface LikesOut {
  /** Created At */
  created_at: string
  /** Created By */
  created_by: string
  /** Updated At */
  updated_at: string
  /** Updated By */
  updated_by: string
  /** Like Id */
  like_id: string
  /** Pub Id */
  pub_id: string
  /** User Id */
  user_id: string
}

/** PromptStyleItemResponse */
export interface PromptStyleItemResponse {
  /**
   * Name
   * @default ""
   */
  name: string
  /**
   * Prompt
   * @default ""
   */
  prompt: string
  /**
   * Negative Prompt
   * @default ""
   */
  negative_prompt: string
}

/** PromptStyleListResponse */
export interface PromptStyleListResponse {
  /**
   * Styles
   * @default []
   */
  styles: PromptStyleItemResponse[]
}

/** PublicationIn */
export interface PublicationIn {
  /** Title */
  title?: string | null
  /** Desc */
  desc?: string | null
  /** Images */
  images: ImagesIn[]
}

/** PublicationOut */
export interface PublicationOut {
  /** Created At */
  created_at: string
  /** Created By */
  created_by: string
  /** Updated At */
  updated_at: string
  /** Updated By */
  updated_by: string
  /** Title */
  title: string | null
  /** Desc */
  desc: string | null
  /** Images */
  images: ImagesOut[]
  /** Pub Id */
  pub_id: string
  /** User Id */
  user_id: string
  /**
   * Cmts
   * @default []
   */
  cmts: CommentsOut[]
  /**
   * Likes
   * @default []
   */
  likes: LikesOut[]
}

/** SDModelListResponse */
export interface SDModelListResponse {
  /**
   * Sd Models
   * @default []
   */
  sd_models: SDModelResponse[]
}

/** SDModelResponse */
export interface SDModelResponse {
  /**
   * Title
   * @default ""
   */
  title: string
  /**
   * Name
   * @default ""
   */
  name: string
  /** Hash */
  hash: string | null
  /** Sha256 */
  sha256: string | null
  /**
   * Filename
   * @default ""
   */
  filename: string
  /** Config */
  config: string | null
}

/** SamplerResponse */
export interface SamplerResponse {
  /**
   * Samplers
   * @default []
   */
  samplers: string[]
}

/** SignInRequest */
export interface SignInRequest {
  /** Username */
  username: string
  /** Password */
  password: string
}

/** TempRequestResponse */
export interface TempRequestResponse {
  /**
   * Type
   * type of request, 'txt2img', 'img2img', 'set_options'
   * @default ""
   * @example "txt2img"
   */
  type: string
  /**
   * Payload
   * payload for the request
   * @default {}
   * @example {"prompt":"A cute cat"}
   */
  payload: object
  /**
   * Request Id
   * uuid for the request
   * @default "194afa23-0d98-4713-894b-a1c0f2e83313"
   * @example "289ef24c-e078-447f-b2ab-d05ac5c84668"
   */
  request_id: string
  /**
   * Status
   * status of the request
   * @default "pending"
   * @example "pending"
   */
  status: string
  /**
   * Position In Queue
   * the position of the request in queue
   * @default 0
   * @example "1"
   */
  position_in_queue: number
  /**
   * Options
   * options for the request
   * @default {}
   * @example {"sd_model_checkpoint":"sd_xl_base_1.0.safetensors"}
   */
  options: object
}

/** Token */
export interface Token {
  /** Access Token */
  access_token: string
  /** Token Type */
  token_type: string
}

/** TokenJson */
export interface TokenJson {
  /** Token */
  token: string
  /** Token Type */
  token_type: string
}

/** Txt2ImgGenerationResponse */
export interface Txt2ImgGenerationResponse {
  /**
   * Images
   * @default []
   */
  images: string[]
  params: Txt2ImgOutput
  /**
   * Info
   * @default {}
   */
  info: any
}

/** Txt2Img */
export interface Txt2ImgInput {
  /**
   * Enable Hr
   * User input: Enable high resolution
   * @default false
   * @example false
   */
  enable_hr?: boolean | null
  /**
   * Denoising Strength
   * User input: Strength for denoising
   * @default 0.7
   * @example 0.7
   */
  denoising_strength?: number | null
  /**
   * Firstphase Width
   * Width in the first phase
   * @default 0
   * @example 0
   */
  firstphase_width?: number | null
  /**
   * Firstphase Height
   * Height in the first phase
   * @default 0
   * @example 0
   */
  firstphase_height?: number | null
  /**
   * Hr Scale
   * High resolution scale factor
   * @default 2
   * @example 2
   */
  hr_scale?: number | null
  /**
   * Hr Upscaler
   * High resolution upscaling method
   * @default "Latent"
   * @example "Latent"
   */
  hr_upscaler?: string | null
  /**
   * Hr Second Pass Steps
   * Number of second pass steps for high resolution
   * @default 0
   * @example 0
   */
  hr_second_pass_steps?: number | null
  /**
   * Hr Resize X
   * Resizing factor along x-axis for high resolution
   * @default 0
   * @example 0
   */
  hr_resize_x?: number | null
  /**
   * Hr Resize Y
   * Resizing factor along y-axis for high resolution
   * @default 0
   * @example 0
   */
  hr_resize_y?: number | null
  /**
   * Hr Sampler Name
   * Sampler name for high resolution
   * @default ""
   * @example "Bicubic"
   */
  hr_sampler_name?: string | null
  /**
   * Hr Prompt
   * Prompt for high resolution
   * @default ""
   * @example "A detailed landscape"
   */
  hr_prompt?: string | null
  /**
   * Hr Negative Prompt
   * Negative prompt for high resolution
   * @default ""
   * @example "No animals"
   */
  hr_negative_prompt?: string | null
  /**
   * Prompt
   * User input: Primary prompt for image generation
   * @default ""
   * @example "A majestic mountain"
   */
  prompt?: string | null
  /**
   * Styles
   * User input: List of styles to be applied
   * @default []
   * @example ["Style: Anime","Style: Digital art"]
   */
  styles?: string[] | null
  /**
   * Seed
   * Random seed for generation
   * @default -1
   * @example -1
   */
  seed?: number | null
  /**
   * Subseed
   * Secondary random seed
   * @default -1
   * @example -1
   */
  subseed?: number | null
  /**
   * Subseed Strength
   * Strength of the subseed
   * @default 0
   * @example 0
   */
  subseed_strength?: number | null
  /**
   * Seed Resize From H
   * Height from which the seed is resized
   * @default 0
   * @example 0
   */
  seed_resize_from_h?: number | null
  /**
   * Seed Resize From W
   * Width from which the seed is resized
   * @default 0
   * @example 0
   */
  seed_resize_from_w?: number | null
  /**
   * Sampler Name
   * Name of the sampler used
   * @default "Euler a"
   * @example "Euler a"
   */
  sampler_name?: string | null
  /**
   * Batch Size
   * User input: Batch size for processing
   * @default 1
   * @example 3
   */
  batch_size?: number | null
  /**
   * N Iter
   * Number of iterations
   * @default 1
   * @example 1
   */
  n_iter?: number | null
  /**
   * Steps
   * Number of processing steps
   * @default 50
   * @example 20
   */
  steps?: number | null
  /**
   * Cfg Scale
   * Scale for the configuration(importance of the prompt)
   * @default 7
   * @example 7
   */
  cfg_scale?: number | null
  /**
   * Width
   * User input: Width of the output image
   * @default 1024
   * @example 1024
   */
  width?: number | null
  /**
   * Height
   * User input: Height of the output image
   * @default 1024
   * @example 1024
   */
  height?: number | null
  /**
   * Restore Faces
   * User input: Should faces be restored
   * @default false
   * @example false
   */
  restore_faces?: boolean | null
  /**
   * Tiling
   * Apply tiling to the image
   * @default false
   * @example false
   */
  tiling?: boolean | null
  /**
   * Do Not Save Samples
   * Should samples not be saved
   * @default false
   * @example false
   */
  do_not_save_samples?: boolean | null
  /**
   * Do Not Save Grid
   * Should grid not be saved
   * @default false
   * @example false
   */
  do_not_save_grid?: boolean | null
  /**
   * Negative Prompt
   * User input: Negative prompt for the image generation
   * @default "nudity, poorly Rendered face, poorly drawn face, poor facial details, poorly drawn hands, poorly rendered hands, low resolution, images cut out at the top, images cut out at the left, images cut out at the right, images cut out at the bottom, bad composition, mutated body parts, blurry image, disfigured, oversaturated, bad anatomy, deformed body features"
   * @example "ugly"
   */
  negative_prompt?: string | null
  /**
   * Eta
   * Eta value for generation
   * @default 1
   * @example 1
   */
  eta?: number | null
  /**
   * S Min Uncond
   * Minimum unconditional value
   * @default 0
   * @example 0
   */
  s_min_uncond?: number | null
  /**
   * S Churn
   * Churn value
   * @default 0
   * @example 0
   */
  s_churn?: number | null
  /**
   * S Tmax
   * Maximum temperature for generation
   * @default 0
   * @example 0
   */
  s_tmax?: number | null
  /**
   * S Tmin
   * Minimum temperature for generation
   * @default 0
   * @example 0
   */
  s_tmin?: number | null
  /**
   * S Noise
   * Noise level
   * @default 1
   * @example 1
   */
  s_noise?: number | null
  /**
   * Override Settings
   * Settings to override default behavior
   * @default {}
   * @example {"mode":"advanced"}
   */
  override_settings?: object | null
  /**
   * Override Settings Restore Afterwards
   * Should settings be restored after operation
   * @default false
   * @example false
   */
  override_settings_restore_afterwards?: boolean | null
  /**
   * Script Args
   * Arguments for the script
   * @default []
   * @example "[]"
   */
  script_args?: any[] | null
  /**
   * Sampler Index
   * Index of the sampler
   * @default ""
   * @example "1"
   */
  sampler_index?: string | null
  /**
   * Script Name
   * Name of the script
   * @default ""
   * @example ""
   */
  script_name?: string | null
  /**
   * Send Images
   * Should images be sent
   * @default true
   * @example true
   */
  send_images?: boolean | null
  /**
   * Save Images
   * Should images be saved
   * @default false
   * @example true
   */
  save_images?: boolean | null
  /**
   * Alwayson Scripts
   * Always on scripts, value depends on controlnet switch
   * @default {}
   * @example {"ControlNet":[{"model":"control_v11p_sd15_canny"},{"module":"openpose"}]}
   */
  alwayson_scripts?: object | null
}

/** Txt2Img */
export interface Txt2ImgOutput {
  /**
   * Enable Hr
   * User input: Enable high resolution
   * @default false
   * @example false
   */
  enable_hr: boolean | null
  /**
   * Denoising Strength
   * User input: Strength for denoising
   * @default 0.7
   * @example 0.7
   */
  denoising_strength: number | null
  /**
   * Firstphase Width
   * Width in the first phase
   * @default 0
   * @example 0
   */
  firstphase_width: number | null
  /**
   * Firstphase Height
   * Height in the first phase
   * @default 0
   * @example 0
   */
  firstphase_height: number | null
  /**
   * Hr Scale
   * High resolution scale factor
   * @default 2
   * @example 2
   */
  hr_scale: number | null
  /**
   * Hr Upscaler
   * High resolution upscaling method
   * @default "Latent"
   * @example "Latent"
   */
  hr_upscaler: string | null
  /**
   * Hr Second Pass Steps
   * Number of second pass steps for high resolution
   * @default 0
   * @example 0
   */
  hr_second_pass_steps: number | null
  /**
   * Hr Resize X
   * Resizing factor along x-axis for high resolution
   * @default 0
   * @example 0
   */
  hr_resize_x: number | null
  /**
   * Hr Resize Y
   * Resizing factor along y-axis for high resolution
   * @default 0
   * @example 0
   */
  hr_resize_y: number | null
  /**
   * Hr Sampler Name
   * Sampler name for high resolution
   * @default ""
   * @example "Bicubic"
   */
  hr_sampler_name: string | null
  /**
   * Hr Prompt
   * Prompt for high resolution
   * @default ""
   * @example "A detailed landscape"
   */
  hr_prompt: string | null
  /**
   * Hr Negative Prompt
   * Negative prompt for high resolution
   * @default ""
   * @example "No animals"
   */
  hr_negative_prompt: string | null
  /**
   * Prompt
   * User input: Primary prompt for image generation
   * @default ""
   * @example "A majestic mountain"
   */
  prompt: string | null
  /**
   * Styles
   * User input: List of styles to be applied
   * @default []
   * @example ["Style: Anime","Style: Digital art"]
   */
  styles: string[] | null
  /**
   * Seed
   * Random seed for generation
   * @default -1
   * @example -1
   */
  seed: number | null
  /**
   * Subseed
   * Secondary random seed
   * @default -1
   * @example -1
   */
  subseed: number | null
  /**
   * Subseed Strength
   * Strength of the subseed
   * @default 0
   * @example 0
   */
  subseed_strength: number | null
  /**
   * Seed Resize From H
   * Height from which the seed is resized
   * @default 0
   * @example 0
   */
  seed_resize_from_h: number | null
  /**
   * Seed Resize From W
   * Width from which the seed is resized
   * @default 0
   * @example 0
   */
  seed_resize_from_w: number | null
  /**
   * Sampler Name
   * Name of the sampler used
   * @default "Euler a"
   * @example "Euler a"
   */
  sampler_name: string | null
  /**
   * Batch Size
   * User input: Batch size for processing
   * @default 1
   * @example 3
   */
  batch_size: number | null
  /**
   * N Iter
   * Number of iterations
   * @default 1
   * @example 1
   */
  n_iter: number | null
  /**
   * Steps
   * Number of processing steps
   * @default 50
   * @example 20
   */
  steps: number | null
  /**
   * Cfg Scale
   * Scale for the configuration(importance of the prompt)
   * @default 7
   * @example 7
   */
  cfg_scale: number | null
  /**
   * Width
   * User input: Width of the output image
   * @default 1024
   * @example 1024
   */
  width: number | null
  /**
   * Height
   * User input: Height of the output image
   * @default 1024
   * @example 1024
   */
  height: number | null
  /**
   * Restore Faces
   * User input: Should faces be restored
   * @default false
   * @example false
   */
  restore_faces: boolean | null
  /**
   * Tiling
   * Apply tiling to the image
   * @default false
   * @example false
   */
  tiling: boolean | null
  /**
   * Do Not Save Samples
   * Should samples not be saved
   * @default false
   * @example false
   */
  do_not_save_samples: boolean | null
  /**
   * Do Not Save Grid
   * Should grid not be saved
   * @default false
   * @example false
   */
  do_not_save_grid: boolean | null
  /**
   * Negative Prompt
   * User input: Negative prompt for the image generation
   * @default "nudity, poorly Rendered face, poorly drawn face, poor facial details, poorly drawn hands, poorly rendered hands, low resolution, images cut out at the top, images cut out at the left, images cut out at the right, images cut out at the bottom, bad composition, mutated body parts, blurry image, disfigured, oversaturated, bad anatomy, deformed body features"
   * @example "ugly"
   */
  negative_prompt: string | null
  /**
   * Eta
   * Eta value for generation
   * @default 1
   * @example 1
   */
  eta: number | null
  /**
   * S Min Uncond
   * Minimum unconditional value
   * @default 0
   * @example 0
   */
  s_min_uncond: number | null
  /**
   * S Churn
   * Churn value
   * @default 0
   * @example 0
   */
  s_churn: number | null
  /**
   * S Tmax
   * Maximum temperature for generation
   * @default 0
   * @example 0
   */
  s_tmax: number | null
  /**
   * S Tmin
   * Minimum temperature for generation
   * @default 0
   * @example 0
   */
  s_tmin: number | null
  /**
   * S Noise
   * Noise level
   * @default 1
   * @example 1
   */
  s_noise: number | null
  /**
   * Override Settings
   * Settings to override default behavior
   * @default {}
   * @example {"mode":"advanced"}
   */
  override_settings: object | null
  /**
   * Override Settings Restore Afterwards
   * Should settings be restored after operation
   * @default false
   * @example false
   */
  override_settings_restore_afterwards: boolean | null
  /**
   * Script Args
   * Arguments for the script
   * @default []
   * @example "[]"
   */
  script_args: any[] | null
  /**
   * Sampler Index
   * Index of the sampler
   * @default ""
   * @example "1"
   */
  sampler_index: string | null
  /**
   * Script Name
   * Name of the script
   * @default ""
   * @example ""
   */
  script_name: string | null
  /**
   * Send Images
   * Should images be sent
   * @default true
   * @example true
   */
  send_images: boolean | null
  /**
   * Save Images
   * Should images be saved
   * @default false
   * @example true
   */
  save_images: boolean | null
  /**
   * Alwayson Scripts
   * Always on scripts, value depends on controlnet switch
   * @default {}
   * @example {"ControlNet":[{"model":"control_v11p_sd15_canny"},{"module":"openpose"}]}
   */
  alwayson_scripts: object | null
}

/** Txt2ImgRequest */
export interface Txt2ImgRequest {
  /** txt2img parameters */
  params: Txt2ImgInput
  /**
   * Controlnet Units
   * List of Control Network Units
   * @default []
   * @example []
   */
  controlnet_units?: ControlNetUnit[] | null
  /**
   * Options
   * Additional options for the request, use to set different base models
   * @default {}
   * @example {"sd_model_checkpoint":"sd_xl_base_1.0.safetensors"}
   */
  options?: object | null
}

/** UserIn */
export interface UserIn {
  /** Username */
  username: string
  /** Email */
  email: string
  /** Password */
  password: string
}

/** UserRead */
export interface UserRead {
  /** Username */
  username: string
  /** Email */
  email: string
}

/** ValidationError */
export interface ValidationError {
  /** Location */
  loc: (string | number)[]
  /** Message */
  msg: string
  /** Error Type */
  type: string
}

export type GetAccessTokenApiV1AuthTokenPostData = Token

export type LoginWithAccessTokenApiV1AuthSigninPostData = TokenJson

export type SignUpApiV1AuthSignupPostData = UserRead

export type GetCurrentUserDetailsApiV1AuthUsersMeGetData = UserRead

export type Txt2ImageRawApiV1CreationsRawtxt2ImgPostData = Txt2ImgGenerationResponse

export type Img2ImageRawApiV1CreationsRawimg2ImgPostData = Img2ImgGenerationResponse

export type Txt2ImageApiV1CreationsTxt2ImgPostData = TempRequestResponse

export type Txt2ImageApiV1CreationsImg2ImgPostData = TempRequestResponse

export type GetCurrentRequestApiV1CreationsRequestsCurrentGetData = any

export type GetCurrentRequestAllApiV1CreationsRequestsCurrentDetailsGetData = any

export type ProgressApiV1CreationsRequestsRequestIdGetData = any

export type InterruptApiV1CreationsRequestsRequestIdPutData = any

export type RemoveApiV1CreationsRequestsRequestIdDeleteData = any

export type AllProgressApiV1CreationsRequestsGetData = any

export type ClearAllApiV1CreationsRequestsDeleteData = any

export type AllResultsApiV1CreationsResultsGetData = any

export type GetSdModelsApiV1CreationsSdModlesGetData = SDModelListResponse

export type GetStylesApiV1CreationsPromptStylesGetData = PromptStyleListResponse

export type GetLorasApiV1CreationsLorasGetData = any

export type GetControlNetModelsApiV1CreationsControlnetModelsGetData = ControlNetModelsResponse

export type GetControlNetModulesApiV1CreationsControlnetModulesGetData = ControlNetModulesResponse

export type GetSamplersApiV1CreationsSamplersGetData = SamplerResponse

/** Response Get All Publications Api V1 Publications  Get */
export type GetAllPublicationsApiV1PublicationsGetData = PublicationOut[]

export type CreatePublicationApiV1PublicationsPostData = PublicationOut

export type UpdatePublicationApiV1PublicationsPubIdPutData = PublicationOut

export type DeletePublicationApiV1PublicationsPubIdDeleteData = any

/** Response Get My Publications Api V1 Publications Mypublications Get */
export type GetMyPublicationsApiV1PublicationsMyPublicationsGetData = PublicationOut[]

export type CreateCommentOnPublicationApiV1PublicationsPubIdCommentsPostData = CommentsOut

/** Response Get Comments For Publication Api V1 Publications  Pub Id  Comments Get */
export type GetCommentsForPublicationApiV1PublicationsPubIdCommentsGetData = CommentsOut[]

export type ReplyToCommentApiV1PublicationsPubIdCommentsParentCmtIdPostData = CommentsOut

export type UpdateCommentApiV1PublicationsPubIdCommentsCommentIdPutData = any

export type DeleteCommentApiV1PublicationsPubIdCommentsCommentIdDeleteData = any

export type LikePublicationApiV1PublicationsPubIdLikesPostData = LikesOut

/** Response Get Likes For Publication Api V1 Publications  Pub Id  Likes Get */
export type GetLikesForPublicationApiV1PublicationsPubIdLikesGetData = LikesOut[]

export type UnlikePublicationApiV1PublicationsPubIdLikesLikeIdDeleteData = any

/** Response Get Images For Publication Api V1 Publications  Pub Id  Images Get */
export type GetImagesForPublicationApiV1PublicationsPubIdImagesGetData = ImagesOut[]

export type GetImageForPublicationByIdApiV1PublicationsPubIdImagesImgIdGetData = ImagesOut

export type DeleteImageApiV1PublicationsPubIdImagesImgIdDeleteData = any

export type DeletePublicationAdminApiV1PublicationsAdminPubIdDeleteData = any

export type ReadRootGetData = any

export type QueryParamsType = Record<string | number, any>
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean
  /** request path */
  path: string
  /** content type of request body */
  type?: ContentType
  /** query params */
  query?: QueryParamsType
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat
  /** request body */
  body?: unknown
  /** base url */
  baseUrl?: string
  /** request cancellation token */
  cancelToken?: CancelToken
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void
  customFetch?: typeof fetch
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D
  error: E
}

type CancelToken = Symbol | string | number

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = ''
  private securityData: SecurityDataType | null = null
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker']
  private abortControllers = new Map<CancelToken, AbortController>()
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams)

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  }

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig)
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data
  }

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key)
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key])
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key]
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&')
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {}
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key])
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&')
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery)
    return queryString ? `?${queryString}` : ''
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key]
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        )
        return formData
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  }

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    }
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken)
      if (abortController) {
        return abortController.signal
      }
      return void 0
    }

    const abortController = new AbortController()
    this.abortControllers.set(cancelToken, abortController)
    return abortController.signal
  }

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken)

    if (abortController) {
      abortController.abort()
      this.abortControllers.delete(cancelToken)
    }
  }

  public request = async <T = any, E = any>(
    { body, secure, path, type, query, format, baseUrl, cancelToken, ...params }: FullRequestParams,
  ): Promise<T> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {}
    const requestParams = this.mergeRequestParams(params, secureParams)
    const queryString = query && this.toQueryString(query)
    const payloadFormatter = this.contentFormatters[type || ContentType.Json]
    const responseFormat = format || requestParams.format

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: (cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal) || null,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>
      r.data = null as unknown as T
      r.error = null as unknown as E

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data
              } else {
                r.error = data
              }
              return r
            })
            .catch((e) => {
              r.error = e
              return r
            })

      if (cancelToken) {
        this.abortControllers.delete(cancelToken)
      }

      if (!response.ok) throw data
      return data.data
    })
  }
}

/**
 * @title FastAPI
 * @version 0.1.0
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @name ReadRootGet
   * @summary Read Root
   * @request GET:/
   * @response `200` `ReadRootGetData` Successful Response
   */
  readRootGet = (params: RequestParams = {}) =>
    this.request<ReadRootGetData, any>({
      path: `/`,
      method: 'GET',
      ...params,
    })

  api = {
    /**
     * No description
     *
     * @name GetAccessTokenApiV1AuthTokenPost
     * @summary Get Access Token
     * @request POST:/api/v1/auth/token
     * @response `200` `GetAccessTokenApiV1AuthTokenPostData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getAccessTokenApiV1AuthTokenPost: (data: BodyGetAccessTokenApiV1AuthTokenPost, params: RequestParams = {}) =>
      this.request<GetAccessTokenApiV1AuthTokenPostData, HTTPValidationError>({
        path: `/api/v1/auth/token`,
        method: 'POST',
        body: data,
        type: ContentType.UrlEncoded,
        ...params,
      }),

    /**
     * No description
     *
     * @name LoginWithAccessTokenApiV1AuthSigninPost
     * @summary Login With Access Token
     * @request POST:/api/v1/auth/signin
     * @response `200` `LoginWithAccessTokenApiV1AuthSigninPostData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    loginWithAccessTokenApiV1AuthSigninPost: (data: SignInRequest, params: RequestParams = {}) =>
      this.request<LoginWithAccessTokenApiV1AuthSigninPostData, HTTPValidationError>({
        path: `/api/v1/auth/signin`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name SignUpApiV1AuthSignupPost
     * @summary Sign Up
     * @request POST:/api/v1/auth/signup
     * @response `200` `SignUpApiV1AuthSignupPostData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    signUpApiV1AuthSignupPost: (data: UserIn, params: RequestParams = {}) =>
      this.request<SignUpApiV1AuthSignupPostData, HTTPValidationError>({
        path: `/api/v1/auth/signup`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCurrentUserDetailsApiV1AuthUsersMeGet
     * @summary Get Current User Details
     * @request GET:/api/v1/auth/users/me
     * @secure
     * @response `200` `GetCurrentUserDetailsApiV1AuthUsersMeGetData` Successful Response
     */
    getCurrentUserDetailsApiV1AuthUsersMeGet: (params: RequestParams = {}) =>
      this.request<GetCurrentUserDetailsApiV1AuthUsersMeGetData, any>({
        path: `/api/v1/auth/users/me`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name Txt2ImageRawApiV1CreationsRawtxt2ImgPost
     * @summary Txt2Imageraw
     * @request POST:/api/v1/creations/rawtxt2img
     * @secure
     * @response `200` `Txt2ImageRawApiV1CreationsRawtxt2ImgPostData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    txt2ImageRawApiV1CreationsRawtxt2ImgPost: (data: Txt2ImgRequest, params: RequestParams = {}) =>
      this.request<Txt2ImageRawApiV1CreationsRawtxt2ImgPostData, HTTPValidationError>({
        path: `/api/v1/creations/rawtxt2img`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name Img2ImageRawApiV1CreationsRawimg2ImgPost
     * @summary Img2Imageraw
     * @request POST:/api/v1/creations/rawimg2img
     * @secure
     * @response `200` `Img2ImageRawApiV1CreationsRawimg2ImgPostData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    img2ImageRawApiV1CreationsRawimg2ImgPost: (data: Img2ImgRequest, params: RequestParams = {}) =>
      this.request<Img2ImageRawApiV1CreationsRawimg2ImgPostData, HTTPValidationError>({
        path: `/api/v1/creations/rawimg2img`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name Txt2ImageApiV1CreationsTxt2ImgPost
     * @summary Txt2Image
     * @request POST:/api/v1/creations/txt2img
     * @secure
     * @response `200` `Txt2ImageApiV1CreationsTxt2ImgPostData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    txt2ImageApiV1CreationsTxt2ImgPost: (data: Txt2ImgRequest, params: RequestParams = {}) =>
      this.request<Txt2ImageApiV1CreationsTxt2ImgPostData, HTTPValidationError>({
        path: `/api/v1/creations/txt2img`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name Txt2ImageApiV1CreationsImg2ImgPost
     * @summary Txt2Image
     * @request POST:/api/v1/creations/img2img
     * @secure
     * @response `200` `Txt2ImageApiV1CreationsImg2ImgPostData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    txt2ImageApiV1CreationsImg2ImgPost: (data: Img2ImgRequest, params: RequestParams = {}) =>
      this.request<Txt2ImageApiV1CreationsImg2ImgPostData, HTTPValidationError>({
        path: `/api/v1/creations/img2img`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCurrentRequestApiV1CreationsRequestsCurrentGet
     * @summary Get Current Request
     * @request GET:/api/v1/creations/requests/current
     * @secure
     * @response `200` `GetCurrentRequestApiV1CreationsRequestsCurrentGetData` Successful Response
     */
    getCurrentRequestApiV1CreationsRequestsCurrentGet: (params: RequestParams = {}) =>
      this.request<GetCurrentRequestApiV1CreationsRequestsCurrentGetData, any>({
        path: `/api/v1/creations/requests/current`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCurrentRequestAllApiV1CreationsRequestsCurrentDetailsGet
     * @summary Get Current Request All
     * @request GET:/api/v1/creations/requests/current/details
     * @secure
     * @response `200` `GetCurrentRequestAllApiV1CreationsRequestsCurrentDetailsGetData` Successful Response
     */
    getCurrentRequestAllApiV1CreationsRequestsCurrentDetailsGet: (params: RequestParams = {}) =>
      this.request<GetCurrentRequestAllApiV1CreationsRequestsCurrentDetailsGetData, any>({
        path: `/api/v1/creations/requests/current/details`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name ProgressApiV1CreationsRequestsRequestIdGet
     * @summary Progress
     * @request GET:/api/v1/creations/requests/{request_id}
     * @secure
     * @response `200` `ProgressApiV1CreationsRequestsRequestIdGetData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    progressApiV1CreationsRequestsRequestIdGet: (requestId: string, params: RequestParams = {}) =>
      this.request<ProgressApiV1CreationsRequestsRequestIdGetData, HTTPValidationError>({
        path: `/api/v1/creations/requests/${requestId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name InterruptApiV1CreationsRequestsRequestIdPut
     * @summary Interrupt
     * @request PUT:/api/v1/creations/requests/{request_id}
     * @secure
     * @response `200` `InterruptApiV1CreationsRequestsRequestIdPutData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    interruptApiV1CreationsRequestsRequestIdPut: (requestId: string, params: RequestParams = {}) =>
      this.request<InterruptApiV1CreationsRequestsRequestIdPutData, HTTPValidationError>({
        path: `/api/v1/creations/requests/${requestId}`,
        method: 'PUT',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name RemoveApiV1CreationsRequestsRequestIdDelete
     * @summary Remove
     * @request DELETE:/api/v1/creations/requests/{request_id}
     * @secure
     * @response `200` `RemoveApiV1CreationsRequestsRequestIdDeleteData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    removeApiV1CreationsRequestsRequestIdDelete: (requestId: string, params: RequestParams = {}) =>
      this.request<RemoveApiV1CreationsRequestsRequestIdDeleteData, HTTPValidationError>({
        path: `/api/v1/creations/requests/${requestId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name AllProgressApiV1CreationsRequestsGet
     * @summary All Progress
     * @request GET:/api/v1/creations/requests
     * @secure
     * @response `200` `AllProgressApiV1CreationsRequestsGetData` Successful Response
     */
    allProgressApiV1CreationsRequestsGet: (params: RequestParams = {}) =>
      this.request<AllProgressApiV1CreationsRequestsGetData, any>({
        path: `/api/v1/creations/requests`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name ClearAllApiV1CreationsRequestsDelete
     * @summary Clear All
     * @request DELETE:/api/v1/creations/requests
     * @secure
     * @response `200` `ClearAllApiV1CreationsRequestsDeleteData` Successful Response
     */
    clearAllApiV1CreationsRequestsDelete: (params: RequestParams = {}) =>
      this.request<ClearAllApiV1CreationsRequestsDeleteData, any>({
        path: `/api/v1/creations/requests`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name AllResultsApiV1CreationsResultsGet
     * @summary All Results
     * @request GET:/api/v1/creations/results
     * @secure
     * @response `200` `AllResultsApiV1CreationsResultsGetData` Successful Response
     */
    allResultsApiV1CreationsResultsGet: (params: RequestParams = {}) =>
      this.request<AllResultsApiV1CreationsResultsGetData, any>({
        path: `/api/v1/creations/results`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetSdModelsApiV1CreationsSdModlesGet
     * @summary Getsdmodels
     * @request GET:/api/v1/creations/sd-modles
     * @response `200` `GetSdModelsApiV1CreationsSdModlesGetData` Successful Response
     */
    getSdModelsApiV1CreationsSdModlesGet: (params: RequestParams = {}) =>
      this.request<GetSdModelsApiV1CreationsSdModlesGetData, any>({
        path: `/api/v1/creations/sd-modles`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetStylesApiV1CreationsPromptStylesGet
     * @summary Getstyles
     * @request GET:/api/v1/creations/prompt-styles
     * @response `200` `GetStylesApiV1CreationsPromptStylesGetData` Successful Response
     */
    getStylesApiV1CreationsPromptStylesGet: (params: RequestParams = {}) =>
      this.request<GetStylesApiV1CreationsPromptStylesGetData, any>({
        path: `/api/v1/creations/prompt-styles`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetLorasApiV1CreationsLorasGet
     * @summary Getloras
     * @request GET:/api/v1/creations/loras
     * @response `200` `GetLorasApiV1CreationsLorasGetData` Successful Response
     */
    getLorasApiV1CreationsLorasGet: (params: RequestParams = {}) =>
      this.request<GetLorasApiV1CreationsLorasGetData, any>({
        path: `/api/v1/creations/loras`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetControlNetModelsApiV1CreationsControlnetModelsGet
     * @summary Getcontrolnetmodels
     * @request GET:/api/v1/creations/controlnet-models
     * @response `200` `GetControlNetModelsApiV1CreationsControlnetModelsGetData` Successful Response
     */
    getControlNetModelsApiV1CreationsControlnetModelsGet: (params: RequestParams = {}) =>
      this.request<GetControlNetModelsApiV1CreationsControlnetModelsGetData, any>({
        path: `/api/v1/creations/controlnet-models`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetControlNetModulesApiV1CreationsControlnetModulesGet
     * @summary Getcontrolnetmodules
     * @request GET:/api/v1/creations/controlnet-modules
     * @response `200` `GetControlNetModulesApiV1CreationsControlnetModulesGetData` Successful Response
     */
    getControlNetModulesApiV1CreationsControlnetModulesGet: (params: RequestParams = {}) =>
      this.request<GetControlNetModulesApiV1CreationsControlnetModulesGetData, any>({
        path: `/api/v1/creations/controlnet-modules`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetSamplersApiV1CreationsSamplersGet
     * @summary Getsamplers
     * @request GET:/api/v1/creations/samplers
     * @response `200` `GetSamplersApiV1CreationsSamplersGetData` Successful Response
     */
    getSamplersApiV1CreationsSamplersGet: (params: RequestParams = {}) =>
      this.request<GetSamplersApiV1CreationsSamplersGetData, any>({
        path: `/api/v1/creations/samplers`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @name GetAllPublicationsApiV1PublicationsGet
     * @summary Get All Publications
     * @request GET:/api/v1/publications/
     * @secure
     * @response `200` `GetAllPublicationsApiV1PublicationsGetData` Successful Response
     */
    getAllPublicationsApiV1PublicationsGet: (params: RequestParams = {}) =>
      this.request<GetAllPublicationsApiV1PublicationsGetData, any>({
        path: `/api/v1/publications/`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name CreatePublicationApiV1PublicationsPost
     * @summary Create Publication
     * @request POST:/api/v1/publications/
     * @secure
     * @response `200` `CreatePublicationApiV1PublicationsPostData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    createPublicationApiV1PublicationsPost: (data: PublicationIn, params: RequestParams = {}) =>
      this.request<CreatePublicationApiV1PublicationsPostData, HTTPValidationError>({
        path: `/api/v1/publications/`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdatePublicationApiV1PublicationsPubIdPut
     * @summary Update Publication
     * @request PUT:/api/v1/publications/{pub_id}
     * @secure
     * @response `200` `UpdatePublicationApiV1PublicationsPubIdPutData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updatePublicationApiV1PublicationsPubIdPut: (pubId: string, data: PublicationIn, params: RequestParams = {}) =>
      this.request<UpdatePublicationApiV1PublicationsPubIdPutData, HTTPValidationError>({
        path: `/api/v1/publications/${pubId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name DeletePublicationApiV1PublicationsPubIdDelete
     * @summary Delete Publication
     * @request DELETE:/api/v1/publications/{pub_id}
     * @secure
     * @response `200` `DeletePublicationApiV1PublicationsPubIdDeleteData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    deletePublicationApiV1PublicationsPubIdDelete: (pubId: string, params: RequestParams = {}) =>
      this.request<DeletePublicationApiV1PublicationsPubIdDeleteData, HTTPValidationError>({
        path: `/api/v1/publications/${pubId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetMyPublicationsApiV1PublicationsMyPublicationsGet
     * @summary Get My Publications
     * @request GET:/api/v1/publications/myPublications
     * @secure
     * @response `200` `GetMyPublicationsApiV1PublicationsMyPublicationsGetData` Successful Response
     */
    getMyPublicationsApiV1PublicationsMyPublicationsGet: (params: RequestParams = {}) =>
      this.request<GetMyPublicationsApiV1PublicationsMyPublicationsGetData, any>({
        path: `/api/v1/publications/myPublications`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name CreateCommentOnPublicationApiV1PublicationsPubIdCommentsPost
     * @summary Create Comment On Publication
     * @request POST:/api/v1/publications/{pub_id}/comments
     * @secure
     * @response `200` `CreateCommentOnPublicationApiV1PublicationsPubIdCommentsPostData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    createCommentOnPublicationApiV1PublicationsPubIdCommentsPost: (
      pubId: string,
      data: CommentsIn,
      params: RequestParams = {},
    ) =>
      this.request<CreateCommentOnPublicationApiV1PublicationsPubIdCommentsPostData, HTTPValidationError>({
        path: `/api/v1/publications/${pubId}/comments`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetCommentsForPublicationApiV1PublicationsPubIdCommentsGet
     * @summary Get Comments For Publication
     * @request GET:/api/v1/publications/{pub_id}/comments
     * @secure
     * @response `200` `GetCommentsForPublicationApiV1PublicationsPubIdCommentsGetData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getCommentsForPublicationApiV1PublicationsPubIdCommentsGet: (pubId: string, params: RequestParams = {}) =>
      this.request<GetCommentsForPublicationApiV1PublicationsPubIdCommentsGetData, HTTPValidationError>({
        path: `/api/v1/publications/${pubId}/comments`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name ReplyToCommentApiV1PublicationsPubIdCommentsParentCmtIdPost
     * @summary Reply To Comment
     * @request POST:/api/v1/publications/{pub_id}/comments/{parent_cmt_id}
     * @secure
     * @response `200` `ReplyToCommentApiV1PublicationsPubIdCommentsParentCmtIdPostData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    replyToCommentApiV1PublicationsPubIdCommentsParentCmtIdPost: (
      pubId: string,
      parentCmtId: string,
      data: CommentsIn,
      params: RequestParams = {},
    ) =>
      this.request<ReplyToCommentApiV1PublicationsPubIdCommentsParentCmtIdPostData, HTTPValidationError>({
        path: `/api/v1/publications/${pubId}/comments/${parentCmtId}`,
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name UpdateCommentApiV1PublicationsPubIdCommentsCommentIdPut
     * @summary Update Comment
     * @request PUT:/api/v1/publications/{pub_id}/comments/{comment_id}
     * @secure
     * @response `200` `UpdateCommentApiV1PublicationsPubIdCommentsCommentIdPutData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    updateCommentApiV1PublicationsPubIdCommentsCommentIdPut: (
      pubId: string,
      commentId: string,
      data: CommentsIn,
      params: RequestParams = {},
    ) =>
      this.request<UpdateCommentApiV1PublicationsPubIdCommentsCommentIdPutData, HTTPValidationError>({
        path: `/api/v1/publications/${pubId}/comments/${commentId}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteCommentApiV1PublicationsPubIdCommentsCommentIdDelete
     * @summary Delete Comment
     * @request DELETE:/api/v1/publications/{pub_id}/comments/{comment_id}
     * @secure
     * @response `200` `DeleteCommentApiV1PublicationsPubIdCommentsCommentIdDeleteData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    deleteCommentApiV1PublicationsPubIdCommentsCommentIdDelete: (
      pubId: string,
      commentId: string,
      params: RequestParams = {},
    ) =>
      this.request<DeleteCommentApiV1PublicationsPubIdCommentsCommentIdDeleteData, HTTPValidationError>({
        path: `/api/v1/publications/${pubId}/comments/${commentId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name LikePublicationApiV1PublicationsPubIdLikesPost
     * @summary Like Publication
     * @request POST:/api/v1/publications/{pub_id}/likes
     * @secure
     * @response `200` `LikePublicationApiV1PublicationsPubIdLikesPostData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    likePublicationApiV1PublicationsPubIdLikesPost: (pubId: string, params: RequestParams = {}) =>
      this.request<LikePublicationApiV1PublicationsPubIdLikesPostData, HTTPValidationError>({
        path: `/api/v1/publications/${pubId}/likes`,
        method: 'POST',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetLikesForPublicationApiV1PublicationsPubIdLikesGet
     * @summary Get Likes For Publication
     * @request GET:/api/v1/publications/{pub_id}/likes
     * @secure
     * @response `200` `GetLikesForPublicationApiV1PublicationsPubIdLikesGetData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getLikesForPublicationApiV1PublicationsPubIdLikesGet: (pubId: string, params: RequestParams = {}) =>
      this.request<GetLikesForPublicationApiV1PublicationsPubIdLikesGetData, HTTPValidationError>({
        path: `/api/v1/publications/${pubId}/likes`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name UnlikePublicationApiV1PublicationsPubIdLikesLikeIdDelete
     * @summary Unlike Publication
     * @request DELETE:/api/v1/publications/{pub_id}/likes/{like_id}
     * @secure
     * @response `200` `UnlikePublicationApiV1PublicationsPubIdLikesLikeIdDeleteData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    unlikePublicationApiV1PublicationsPubIdLikesLikeIdDelete: (
      pubId: string,
      likeId: string,
      params: RequestParams = {},
    ) =>
      this.request<UnlikePublicationApiV1PublicationsPubIdLikesLikeIdDeleteData, HTTPValidationError>({
        path: `/api/v1/publications/${pubId}/likes/${likeId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetImagesForPublicationApiV1PublicationsPubIdImagesGet
     * @summary Get Images For Publication
     * @request GET:/api/v1/publications/{pub_id}/images
     * @secure
     * @response `200` `GetImagesForPublicationApiV1PublicationsPubIdImagesGetData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getImagesForPublicationApiV1PublicationsPubIdImagesGet: (pubId: string, params: RequestParams = {}) =>
      this.request<GetImagesForPublicationApiV1PublicationsPubIdImagesGetData, HTTPValidationError>({
        path: `/api/v1/publications/${pubId}/images`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name GetImageForPublicationByIdApiV1PublicationsPubIdImagesImgIdGet
     * @summary Get Image For Publication By Id
     * @request GET:/api/v1/publications/{pub_id}/images/{img_id}
     * @secure
     * @response `200` `GetImageForPublicationByIdApiV1PublicationsPubIdImagesImgIdGetData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    getImageForPublicationByIdApiV1PublicationsPubIdImagesImgIdGet: (
      pubId: string,
      imgId: string,
      params: RequestParams = {},
    ) =>
      this.request<GetImageForPublicationByIdApiV1PublicationsPubIdImagesImgIdGetData, HTTPValidationError>({
        path: `/api/v1/publications/${pubId}/images/${imgId}`,
        method: 'GET',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name DeleteImageApiV1PublicationsPubIdImagesImgIdDelete
     * @summary Delete Image
     * @request DELETE:/api/v1/publications/{pub_id}/images/{img_id}
     * @secure
     * @response `200` `DeleteImageApiV1PublicationsPubIdImagesImgIdDeleteData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    deleteImageApiV1PublicationsPubIdImagesImgIdDelete: (pubId: string, imgId: string, params: RequestParams = {}) =>
      this.request<DeleteImageApiV1PublicationsPubIdImagesImgIdDeleteData, HTTPValidationError>({
        path: `/api/v1/publications/${pubId}/images/${imgId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @name DeletePublicationAdminApiV1PublicationsAdminPubIdDelete
     * @summary Delete Publication Admin
     * @request DELETE:/api/v1/publications/admin/{pub_id}
     * @secure
     * @response `200` `DeletePublicationAdminApiV1PublicationsAdminPubIdDeleteData` Successful Response
     * @response `422` `HTTPValidationError` Validation Error
     */
    deletePublicationAdminApiV1PublicationsAdminPubIdDelete: (pubId: string, params: RequestParams = {}) =>
      this.request<DeletePublicationAdminApiV1PublicationsAdminPubIdDeleteData, HTTPValidationError>({
        path: `/api/v1/publications/admin/${pubId}`,
        method: 'DELETE',
        secure: true,
        ...params,
      }),
  }
}
